export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const footerLinks = [
    {
      title: '快速导航',
      links: [
        { label: '首页', href: '#hero' },
        { label: '热门榜单', href: '#ranking' },
        { label: '精彩推荐', href: '#media' },
        { label: '热门分类', href: '#cards' },
        { label: '常见问题', href: '#faq' },
        { label: '最新动态', href: '#updates' },
      ],
    },
    {
      title: '同类平台',
      links: [
        { label: '樱花视频', href: '#about' },
        { label: '糖豆视频', href: '#about' },
        { label: '蘑菇视频', href: '#about' },
        { label: '黄桃视频APP', href: '#app' },
      ],
    },
    {
      title: '服务支持',
      links: [
        { label: '联系我们', href: '#contact' },
        { label: '常见问题', href: '#faq' },
        { label: '用户评价', href: '#comments' },
        { label: '平台优势', href: '#features' },
      ],
    },
    {
      title: '合作伙伴',
      links: [],
    },
  ];

  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
            {footerLinks.map((col) => (
              <div key={col.title}>
                <h4 className="text-sm font-semibold text-background-50 mb-4">
                  {col.title}
                </h4>
                <ul className="space-y-2.5">
                  {col.links.length === 0 && col.title === '合作伙伴' ? (
                    <li className="text-sm text-background-500">
                      虚位以待
                    </li>
                  ) : (
                    col.links.map((link) => (
                      <li key={link.label}>
                        <a
                          href={link.href}
                          onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                          className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer"
                        >
                          {link.label}
                        </a>
                      </li>
                    ))
                  )}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-background-800/60">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-play-fill text-background-50 text-sm"></i>
                </span>
                <span className="text-base font-heading font-bold text-background-100">
                  黄桃视频
                </span>
              </div>
              <p className="text-sm text-background-500 text-center sm:text-right">
                黄桃视频 — 与樱花视频、糖豆视频、蘑菇视频同类视频平台，提供免费高清在线观看服务，海量影视资源不缓冲。
                <br />
                <span className="text-background-600">本站内容仅供交流学习，请支持正版。</span>
              </p>
            </div>
            <p className="mt-6 text-xs text-background-600 text-center">
              &copy; {new Date().getFullYear()} 黄桃视频 huangtao.video 版权所有
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}